import API from '../Services/API';
import Model from './Model';

const useExpandShortLink = (code) => {
    return Model({
        returnDataKey: 'link',
        stateKey: ['short-link', code],
        defaultData: null,
        assumeLoading: true,
        fetchData: () => API.get(`short-urls/${code}`),
        defaultLoadingError: 'Sorry, there was an error loading the link.',
    })
}

const useShortenUrls = (urls) => {
    const parts = Object.keys(urls).map((k) => 'urls[' + k + ']=' + encodeURIComponent(urls[k]))
    return Model({
        block: !urls || urls.length === 0,
        returnDataKey: 'shortUrls',
        stateKey: ['shortenUrls', parts.join('&')],
        fetchData: () => API.get('/short-urls?' + parts.join('&')),
        defaultLoadingError: 'Sorry, there was an error shortening the urls.',
    })
}

export {
    useExpandShortLink,
    useShortenUrls,
}
